export default __webpack_public_path__ + "static/media/pictogramBeaconTrauma64.0749a733.svg";